(ns frontend.view.entity-viewers.modules.entity-esign.view
  (:require
   [common.localization :as loc]
   [frontend.view.entity-viewers.modules.entity-esign.event :as event]
   [frontend.view.entity-viewers.modules.entity-esign.signatory.view :as signatory]
   [frontend.view.entity-viewers.modules.entity-esign.status-tag.view :as status-tag]
   [frontend.view.entity-viewers.modules.entity-esign.sub :as sub]
   [frontend.view.modals.entity-esign.view :as entity-esign-modal]
   [frontend.view.modals.events :as modals]
   [frontend.view.nev.events :as nev-events]
   [re-frame.core :as rf]
   [reagent.core :as r]
   [ui.components.radix-ui.dropdown-menu.view :as radix-dropdown]
   [common.schema.entities.esign-process-status :as process-status]
   [ui.components.button.view :as button]
   [ui.util :as uu]
   [frontend.state.current-session :as session]
   [frontend.subscription :as subscription]))

(defn esign-process-row
  [esign-process]
  [:div {:class "flex justify-between gap-1.5"}
   (let [signed? (= :esign-process.status/signed (:esign-process/status esign-process))
         view-attachments (:common/attachments esign-process)
         reminding-signatory-ids @(rf/subscribe [::sub/reminding-signatory-ids])
         status (:esign-process/status esign-process)
         signatories (:esign-process/signatories esign-process)
         signatory-count (count signatories)
         esign-v2-process? (:esign-process/esign-v2? esign-process)
         show-esign-process-version? @session/show-esign-process-version?]
     ^{:key (str "esign-process-signatory-" (:db/id esign-process))}
     [radix-dropdown/view
      {:trigger-as-child [:div
                          {:class "w-full p-2 flex flex-col transition hover:bg-complement-light"}
                          [:div
                           {:class "flex justify-between items-center gap-1.5"}
                           [:<>
                            [:div
                             {:class "flex justify-between items-center gap-1.5"}
                             [:a
                              (or (:attachment/filename view-attachments)
                                  (loc/tr :uploading.dot.dot))]
                             [status-tag/view
                              {:label (if (some #{status} [:esign-process.status/not-started
                                                           :esign-process.status/started
                                                           :esign-process.status/document-uploaded
                                                           :esign-process.status/sent])
                                        (loc/tr :in-progress)
                                        (process-status/get-label status))
                               :variant (case status
                                          :esign-process.status/signed :success
                                          :esign-process.status/failed :danger
                                          :esign-process.status/declined :danger
                                          :neutral)}]

                             (when show-esign-process-version?
                               [:div
                                {:class "text-sm m-0 text-base-light-text-paler"}
                                (if esign-v2-process? "V2" "V1")])]
                            [:span [:i.fal.fa-ellipsis-v]]]]]
       :items            (concat
                          [{:label          (loc/tr :esign-signatories)
                            :section-label? true
                            :custom-class   ""}]
                          (->> signatories
                               (map-indexed
                                (fn [index {:keys [db/id signatory/email] :as s}]
                                  (let [last? (= index (dec signatory-count))]
                                    ^{:key (str "esign-process-signatory-" (:db/id esign-process) "-" id)}
                                    {:value [:div
                                             {:class (uu/cm "grow hover:bg-base-light"
                                                            (when-not last?
                                                              "border border-x-0 border-t-0 rounded-b-none"))}
                                             [signatory/view
                                              {:signatory s
                                               :signatory-name (:signatory/name s)
                                               :email email
                                               :signed? (:signatory/signed? s)
                                               :last-reminded-on (:signatory/last-reminded-on s)
                                               :processing? (contains? reminding-signatory-ids id)
                                               :on-remind (fn []
                                                            (let [event-kw (if esign-v2-process?
                                                                             ::event/v2-send-reminder-comment
                                                                             ::event/send-reminder-comment)]
                                                              (rf/dispatch [event-kw {:esign-process-id (:db/id esign-process)
                                                                                      :email email
                                                                                      :signatory-id id}])))}]]
                                     :custom-item? true
                                     :separator    true})))
                               (doall))
                          [{:label          (loc/tr :esign-actions)
                            :section-label? true
                            :custom-class   ""}
                           {:label        (loc/tr :esign-view-file)
                            :value        "first-item"
                            :on-click     (fn []
                                            (rf/dispatch [::event/download-contract (:db/id esign-process)
                                                          (:db/id view-attachments)]))
                            :custom-class ""}]
                          (when-not signed?
                            [{:label        (loc/tr :cancel-process)
                              :value        "second-item"
                              :on-click     (fn []
                                              (let [event-kw (if esign-v2-process?
                                                               ::event/v2-cancel-esign-process
                                                               ::event/cancel-esign-process)]
                                                (rf/dispatch [event-kw (:db/id esign-process)])))
                              :custom-class ""}]))
       :props            {:background-color "#fff"
                          :padding          "0px"
                          :align            "end"
                          :content-class "w-[450px] max-w-[450px] shadow"}}])])

(defn view
  [{:keys [entity]}]
  (let [entity-id (:db/id entity)
        subscription-id (keyword (str "esign-entity-updates-" entity-id))]
    (r/create-class
     {:component-did-mount
      (fn [_]
        (rf/dispatch [::event/get-client-safe-configurations])
        (subscription/open subscription-id
                           :entity-updates
                           {:entity-id entity-id}
                           (fn [{:keys [entities]}]
                             (rf/dispatch [::event/process-updates {:entity-id entity-id
                                                                    :entities entities}])
                             (nev-events/updates-to-session-state entities)
                             :ok)))
      :component-will-unmount
      (fn [_]
        (subscription/close subscription-id))
      :reagent-render
      (fn [{:keys [entity]}]
        (let [entity-id (:db/id entity)
              configurations-loaded? @(rf/subscribe [::sub/configurations-loaded?])
              esign-configured-for-entity? @(rf/subscribe [::sub/esign-configured-for-entity? entity])
              esign-processes @(rf/subscribe [::sub/non-cancelled-processes entity-id])]
          [:div
           {:class "flex flex-col gap-2"}
           (cond
             (not configurations-loaded?)
             [:h2
              {:class "mb-0 ml-2 text-sm text-base-light-text-paler"}
              (loc/tr :loading)]

             (not esign-configured-for-entity?)
             [:h2
              {:class "mb-0 ml-2 text-sm text-base-light-text-paler"}
              (loc/tr :esign-provider-not-configured)]
             (empty? esign-processes)
             [:h2
              {:class "mb-0 ml-2 text-sm text-base-light-text-paler"}
              (loc/tr :no-esign-processes
                      ["e-signatures"])]
             :else
             (->> esign-processes
                  (map
                   (fn [esign-process]
                     ^{:key (str "esign-process-key-" (:db/id esign-process))}
                     [esign-process-row esign-process]))))]))})))

(defn header-view
  [{:keys [entity]}]
  (let [configurations-loaded? @(rf/subscribe [::sub/configurations-loaded?])
        esign-configured-for-entity? @(rf/subscribe [::sub/esign-configured-for-entity? entity])]
    [button/secondary-open
     {:tooltip (when configurations-loaded?
                 (if esign-configured-for-entity?
                   (loc/tr :esign-document)
                   (loc/tr :esign-missing-credentials)))}
     [:i.fal.fa-plus-circle.create-option__icon
      {:on-click (when esign-configured-for-entity?
                   (fn []
                     (modals/open-modal!
                      entity-esign-modal/modal-key
                      {:oppo-id (:db/id entity)})))}]]))
